import { render } from "./PayGrade.vue?vue&type=template&id=6e6f7b38"
import script from "./PayGrade.vue?vue&type=script&lang=js"
export * from "./PayGrade.vue?vue&type=script&lang=js"

import exportComponent from "/app/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__